import fuzzyLogicSoilAttribute from './fuzzyLogicSoilAttribute';

export const DROUGHT_VULNERABLE_SOILS = fuzzyLogicSoilAttribute({
  fuzzyLogicRuleName: 'FOR - Drought Vulnerable Soils',
  key: 'Drought Vulnerable Soils',
  ruleId: '2834',
  shortFormData: { AggregationMethod: 'Dominant Condition' },
});
